import { DatePipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MapInteractionEvent } from '../interfaces/map-interaction-event.interface';
import { VdoButtonStrokedMiniComponent, VdoIconComponent } from 'ui-kit';
import { ITrackerEventList } from '../../../../modules/location/pages/location/interfaces/tracker-event-list.interface';

@Component({
  selector: 'vdo-map-maker-details',
  imports: [VdoButtonStrokedMiniComponent, VdoIconComponent, TranslatePipe, DatePipe],
  templateUrl: './vdo-map-maker-details.component.html',
  styleUrl: './vdo-map-maker-details.component.scss',
})
export class VdoMapMakerDetailsComponent {
  data = input<ITrackerEventList>();
  isBlocked = false;
  executeEvent = output<MapInteractionEvent>();

  router = inject(Router);

  navigateToReferencePoint() {
    const { gpsLatitude, gpsLongitude } = this.data() ?? {};

    if (!gpsLatitude || !gpsLongitude) {
      return;
    }

    this.router.navigate(['/perimetros/ponto-de-referencia/criar'], {
      queryParams: {
        lat: gpsLatitude,
        lng: gpsLongitude,
      },
    });
  }

  navigateToLastRecords() {
    const { vehicleId } = this.data() ?? {};

    if (!vehicleId) {
      return;
    }

    this.router.navigate(['/ultimos-registros'], {
      queryParams: {
        filter: vehicleId,
      },
    });
  }
}
